import api from './authService'
import type { ApiKey } from '../types'

export interface ApiKeysListResponse {
  keys: ApiKey[]
  count: number
}

export interface CreateApiKeyResponse {
  id: string
  app_id: string
  app_name?: string
  bundle_id?: string
  key_prefix: string
  name: string
  created_at: string
  is_active: boolean
  api_key: string
  warning: string
}

export const apiKeysService = {
  async listKeys(): Promise<ApiKeysListResponse> {
    const response = await api.get('/api/keys')
    return response.data
  },

  async createKey(appId: string, name?: string): Promise<CreateApiKeyResponse> {
    const response = await api.post('/api/keys', { name, app_id: appId })
    return response.data
  },

  async revokeKey(id: string): Promise<void> {
    await api.post(`/api/keys/${id}/revoke`)
  },
}

